var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTutupKasir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "7.807 9.423 25.778 25.078",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(255, 198, 53)",
      paintOrder: "fill",
      strokeOpacity: 0
    },
    cx: 20.703,
    cy: 21.915,
    rx: 12.621,
    ry: 12.406
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2704_767)",
    transform: "matrix(1, 0, 0, 1, -1.66917, 7.484302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.5 23.25 C 17.667 23.25 13.75 19.333 13.75 14.5 C 13.75 9.667 17.667 5.75 22.5 5.75 C 23.859 5.749 25.199 6.065 26.414 6.672 C 27.629 7.28 28.686 8.163 29.5 9.25 L 27.129 9.25 C 26.118 8.359 24.872 7.779 23.54 7.578 C 22.208 7.378 20.846 7.566 19.619 8.121 C 18.391 8.675 17.349 9.572 16.618 10.704 C 15.888 11.835 15.499 13.154 15.499 14.501 C 15.499 15.848 15.888 17.167 16.619 18.298 C 17.35 19.43 18.392 20.327 19.62 20.881 C 20.848 21.435 22.209 21.623 23.541 21.422 C 24.873 21.222 26.119 20.641 27.13 19.75 L 29.501 19.75 C 28.687 20.838 27.63 21.72 26.414 22.328 C 25.199 22.935 23.859 23.251 22.5 23.25 Z M 28.625 18 L 28.625 15.375 L 21.625 15.375 L 21.625 13.625 L 28.625 13.625 L 28.625 11 L 33 14.5 L 28.625 18 Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2704_767",
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_767"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2704_767",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2704_767"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(12 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutupKasir);
export default __webpack_public_path__ + "static/media/tutupKasir.9ae443bbcb242d7b81a906b1c712962a.svg";
export { ForwardRef as ReactComponent };